import { useEffect, useState } from "react";
import { useTheme } from "../../../../components/hooks/useTheme";
import colorConfigs from "../../../../configs/colorConfigs";
import { RelocationsList } from "./RelocationsList";
import { AddRelocation } from "./AddRelocation";

const filterItems = [
    {
        id: 0,
        label: "From Location",
    },
    {
        id: 1,
        label: "To Location",
    },
]

type RelocationProps = {
    idNumber: any;
    vehicleDetails: {
        currentLocationId: string;
        odometer: number;
        fuelLevel: string;
    };
}

export const Relocations = ({
    idNumber,
    vehicleDetails
}: RelocationProps) => {
    const { themeStyles } = useTheme();
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });
    const [searchValue, setSearchValue] = useState<string>("");
    const [relocationFilterValue, setRelocationFilterValue] = useState(0);
    const [selectedFilter, setSelectedFilter] = useState<string>(filterItems[0].label);
    const [openAddRelocation, setOpenAddRelocation] = useState<boolean>(false);
    const [refreshRelocationList, setRefreshRelocationList] = useState<boolean>(false);

    useEffect(() => {
        if (refreshRelocationList) {
            setPaginationModel({
                page: 0,
                pageSize: 10,
            })
            setSearchValue("");
            setRefreshRelocationList(false);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshRelocationList])

    return (
        <>
            <div className={`px-[24px] py-[20px] min-h-screen h-full`}>

                <div className="flex items-center justify-end">
                    <div className="flex items-center gap-2.5">
                        <button className={`px-[8px] py-[6px] ${colorConfigs.btn.main.tailwind} rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                            onClick={() => setOpenAddRelocation(true)}
                        >
                            <span className="material-symbols-outlined text-[25px] font-light">
                                add
                            </span>
                            <span className="text-xs font-medium">Relocation</span>
                        </button>
                    </div>
                </div>
                <div>
                    <RelocationsList
                        paginationModel={paginationModel}
                        setPaginationModel={setPaginationModel}
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                        relocationFilterValue={relocationFilterValue}
                        setRelocationFilterValue={setRelocationFilterValue}
                        selectedFilter={selectedFilter}
                        setSelectedFilter={setSelectedFilter}
                        filterItems={filterItems}
                        idNumber={idNumber}
                        setRefreshRelocationList={setRefreshRelocationList}
                    />
                </div>
            </div>
            {
                openAddRelocation && (
                    <AddRelocation
                        idNumber={idNumber}
                        vehicleDetails={vehicleDetails}
                        openAddRelocation={openAddRelocation}
                        setOpenAddRelocation={setOpenAddRelocation}
                        setRefreshRelocationList={setRefreshRelocationList}
                    />
                )
            }
        </>

    )
}